// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2385":"eb805be6","5202":"daf2524e","8228":"7a80f3d1"}[chunkId] + ".chunk.css";
};